import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons/faCircleExclamation"
import {
    ActionBanner,
    ColorSchemes,
    Text,
} from "@mallardbay/lib-react-components"
import React from "react"

import COPY from "~config/copy-constants"

interface Props {
    readonly hasAvailability: boolean
    readonly hasPackages: boolean
}

export default function NoAvailabilityCard({
    hasAvailability,
    hasPackages,
}: Props) {
    if (hasAvailability || !hasPackages) {
        return null
    }

    return (
        <ActionBanner
            title={COPY.NO_AVAILABILITY_TITLE}
            colorScheme={ColorSchemes.Red}
            icon={faCircleExclamation}
            hideIconBackground
        >
            <Text>{COPY.NO_AVAILABILITY_DESCRIPTION}</Text>
        </ActionBanner>
    )
}
